import MovieCard from './MovieCard'
import Loader from '../common/Loader'
import './MovieGrid.css'

function MovieGrid({ movies, loading, showRating = false, emptyMessage = 'No hay películas' }) {
  if (loading) {
    return <Loader />
  }

  if (!movies || movies.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">🎬</div>
        <p>{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="movie-grid">
      {movies.map((movie, index) => (
        <div 
          key={movie.id || movie.tmdbId || index} 
          className="movie-grid-item"
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <MovieCard 
            movie={movie} 
            showRating={showRating}
            userRating={movie.rating}
          />
        </div>
      ))}
    </div>
  )
}

export default MovieGrid
